import { Organization, OrganizationMetadata } from '@/models/user';

export const organizations: {
  [key: string]: OrganizationMetadata;
} = {
  'ae8a45c6-8f89-46b7-a051-c727d3efdb02': {
    name: 'Test',
    slug: 'test',
    suggestions: [],
  },
  'cc8e2b77-f4b0-425c-a9f2-389f1db1a459': {
    name: 'DFS',
    slug: 'dfs',
    logo: '/dfs-logo-white.png',
    suggestions: [
      'Which partners does DFS work with?',
      'What relationship DFS has with the IFRC?',
      'What are the main sources used by GANNET in its base of knowledge?',
      'What does DFS do in the humanitarian sector?',
    ],
  },
  '27e5aa22-11e1-4ab6-90a1-e016ee758e50': {
    name: 'IPC',
    slug: 'ipc',
    logo: '/ipc-logo.png',
    suggestions: [
      'What is the current food security situation in Somalia',
      'What are the key drivers of food insecurity in the Gaza Strip',
      'Provide food security facts about the Democratic Republic of Congo',
      'What is the current food security situation in Sudan',
      'Show me the latest update on food insecurity in Ethiopia',
      'What are the humanitarian responses to the food crisis in Yemen',
    ],
  },
};

export const getOrganization = (orgId: string): Organization => {
  const metadata = organizations[orgId];
  return metadata
    ? {
        id: orgId,
        ...metadata,
      }
    : {
        id: orgId,
        name: 'Unknown Organization',
        slug: 'unknown',
        suggestions: [],
      };
};
